import LandmarkRenderer from '../layouts/landmark_renderer';
import {
  CELL_SIZE
} from '../layouts/render_properties';
import { Group, loadSVGFromString, util } from 'fabric';


// major differences between this and default renderer are setupEventListeners is not called and
// the addition of the selectable and evented traits set to false
export default class LayoutFilterLandmarkRenderer extends LandmarkRenderer {
  async renderSVG() {
    const response = await fetch(this.landmark.svgURL);
    const { objects, options } = await loadSVGFromString(await response.text());
    const obj = util.groupSVGElements(objects, options);
    this.svg = obj;
    const { width, height } = obj;
    const scaleX = (this.landmark.width * CELL_SIZE) / width;
    const scaleY = (this.landmark.height * CELL_SIZE) / height;
    this.label = this.renderLabel(this.landmark.label);
    obj.set({ scaleX: scaleX, scaleY: scaleY, originX: 'center', originY: 'center', opacity: 0.8 });
    this.renderedElement = new Group([this.label, this.svg], {
      left: this.landmark.topLeftX * CELL_SIZE,
      top: this.landmark.topLeftY * CELL_SIZE,
      angle: this.landmark.rotation,
      originX: 'left',
      originY: 'top',
      selectable: false,
      evented: false
    });
    this.canvas.add(this.renderedElement);
    this.canvas.sendObjectToBack(this.renderedElement);
  }
}
